import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '@4beefopag/4bee-fopag-core/dist/services/hooks';
import { Col, Row } from 'antd';
import { CheckCircleTwoTone, WarningFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import LabelValue from '../../atoms/LabelValue';
import BwgButton from '../../atoms/Button';
import PayrollDetailSection from '../../molecules/PayrollDetailSection';
import { PAYROLL_TRANSMISSION_ORIGIN_LABELS } from '../../../services/util/globalConstant';
import { Subjects, useUserPolicy } from '../../../user-policy';

export default function PayrollDetail({ payroll = {}, loading, onViewCooperatorsClick, items }) {
  const [paidItemsCount, setPaidItemsCount] = useState(0);
  const totalItemsCount = items ? items.length : 0;

  const folha = payroll.folha ? payroll.folha : {};
  const { isAdmin: checkUserIsAdmin } = useContext(AuthContext);
  const { userAccount } = useUserPolicy();
  const isAdmin = checkUserIsAdmin();
  const canShowApdataInfo = userAccount.ability.can('view', 'payroll.apdata-info');
  const canViewTransmissionOrigin = userAccount.ability.can('view', Subjects.PAYROLL_TRANSMISSION);
  const transmissionOriginLabel = PAYROLL_TRANSMISSION_ORIGIN_LABELS[payroll.transmissionOrigin] || '-';

  const tiposFolha = {
    M: 'Mensal',
    A: 'Adiantamento',
  };

  const tipoFolha = payroll.tipo ? tiposFolha[payroll.tipo] : '-';

  useEffect(() => {
    if (items) {
      let paidCount = 0;

      items.forEach((item) => {
        if (item.paidDate) {
          paidCount += 1;
        }
      });

      setPaidItemsCount(paidCount);
    }
  }, [items]);

  const PaidStatusIcon =
    paidItemsCount === totalItemsCount ? (
      <CheckCircleTwoTone twoToneColor="#52c41a" />
    ) : (
      <WarningFilled style={{ color: '#FAAD14' }} />
    );

  return (
    <PayrollDetailSection title="Dados da Requisição">
      <Row>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Nome da Folha"
            value={folha.name || '-'}
            loading={loading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="ID Folha"
            value={folha.id || '-'}
            loading={loading}
          />
        </Col>
        {canShowApdataInfo && (
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <LabelValue
              label="Log Transação"
              value={payroll.gaTransactionLogId || '-'}
              loading={loading}
            />
          </Col>
        )}
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Qtd de Cooperados Pagos"
            value={
              <>
                {paidItemsCount} de {totalItemsCount} {PaidStatusIcon}
                <BwgButton
                  type="link"
                  onClick={onViewCooperatorsClick}
                >
                  Ver Detalhes
                </BwgButton>
              </>
            }
            loading={loading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Tipo de Folha"
            value={tipoFolha}
            loading={loading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Relacionamento"
            value={folha.relacionamento || '-'}
            loading={loading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Carteira"
            value={folha.carteiraFolha || '-'}
            loading={loading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <LabelValue
            label="Número da Requisição"
            value={payroll.id || '-'}
            loading={loading}
          />
        </Col>
        {canViewTransmissionOrigin && (
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <LabelValue
              label="Transmissão"
              value={transmissionOriginLabel}
              loading={loading}
            />
          </Col>
        )}
        <Col
          xs={24}
          md={12}
          lg={12}
        >
          <LabelValue
            label="Observações"
            value={payroll.observacao || '-'}
            loading={loading}
          />
        </Col>
        {isAdmin && (
          <Col
            xs={24}
            md={12}
            lg={12}
          >
            <LabelValue
              label="Obs. Analista"
              value={payroll.observacaoAdmin || '-'}
              loading={loading}
            />
          </Col>
        )}
      </Row>
    </PayrollDetailSection>
  );
}

PayrollDetail.propTypes = {
  payroll: PropTypes.shape(),
  loading: PropTypes.bool,
  onViewCooperatorsClick: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

PayrollDetail.defaultProps = {
  payroll: {},
  loading: false,
};
